<mat-form-field *ngIf="dateFormat">
  <input
    *ngIf="disableWE"
    type="hidden"
    [matDatepicker]="picker"
    [matDatepickerFilter]="filterDisableWeekend"
    [(ngModel)]="valueIn"
    (ngModelChange)="onChange($event)"
    [min]="min"
    [max]="max"
  />
  <input
    *ngIf="!disableWE"
    type="hidden"
    [matDatepicker]="picker"
    [(ngModel)]="valueIn"
    (ngModelChange)="onChange($event)"
    [min]="min"
    [max]="max"
  />
  <input
    matInput
    [mask]="mask.mask"
    showMaskTyped="true"
    [ngModel]="valueIn | date: dateFormat"
    (blur)="onBlur()"
    (change)="todate($event.target.value)"
  />
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker (selectedChanged)="onChange($event)" #picker></mat-datepicker>
</mat-form-field>
<!--{{ value }}-->
<!--{{ innerValue }}-->
